import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  licenseTitle: {
    id: 'course-authoring.schedule-section.license.title',
    defaultMessage: 'Course content license',
  },
  licenseDescription: {
    id: 'course-authoring.schedule-section.license.description',
    defaultMessage: 'Select the default license for course content',
  },
});

export default messages;
